<template>

	<div class="analysis">
		<!--v-if="idshow"-->
		<div class="Genhead f-cb" style="">
			<div class="f-fl">
				<p class="ID-box item"><span class="tit" v-if="idcode === ''">IDcode编码：</span> <span class="context">{{idcode}}  </span> </p>
				<p class="MA-box item"><span class="tit" v-if="maid===''">码标：</span> <span class="context">{{maid}}  </span>
					<!--<el-input v-model="form.ObjectsCode" size="small" style="width: 40%;margin-left: 10px;"></el-input>-->
				</p>
			</div>

		</div>

		<p style="padding: 10px;font-size: 14px;">当前解析地址：<span> {{analysisData.currentAnalyUrl }}</span> </p>
		<el-form ref="form" :model="form" label-width="100px" :rules="rules">
			<el-form-item label="解析地址：" prop='name'>
				<el-input v-model.trim="form.name" style="width: 60%;">
					<!--<span></span>-->
					<!--<template slot="prepend">Http://</template>-->
				</el-input>
				<span style="color: #1B59A8;"> {{analysisData.tips}}</span>
			</el-form-item>
			<el-form-item label="测试地址：" prop='test'>
				<el-input v-model.trim="form.test" style="width: 60%;">
					<!--<template slot="prepend">Http://</template>-->
				</el-input>
			</el-form-item>

			<el-form-item>
				<div class="identity-box">
					<p style="padding: 10px 0;"> 温馨提示：如有疑问可联系相关注册商进行咨询</p>
					<span>注册商名称：{{analysisData.agentName}} </span><br />
					<span>注册商联系电话：{{analysisData.agentPhone}} </span>
				</div>
				<div class="notice">
					<p>举例说明一：假如您所填写的解析地址为：http://www.xxxx.com/xxxx.aspx?id=1，则拍码后跳转的网址为：</p>
					<p> （注册码）http://www.xxxx.com/xxxx.aspx?id=1<span class="sign">&code=MA.156.110108.52/91.12000000.1/xxxx</span> </p>
					<p> （备案码）http://www.xxxx.com/xxxx.aspx?id=1<span class="sign">&code=xxxx&BaseCode=MA.156.110108.52/91.12000000.1/</span> </p>
					<p> 举例说明二：假如您所填写的解析地址为：http://www.xxxx.com/xxxx.aspx?id=，则拍码后跳转的网址为： </p>
					<p> （注册码）http://www.xxxx.com/xxxx.aspx?id=MA.156.110108.52/91.12000000.1/xxxx </p>
					<p> （备案码）http://www.xxxx.com/xxxx.aspx?id=xxxx&BaseCode=MA.156.110108.52/91.12000000.1/ </p>
					<p>举例说明三：假如您所填写的解析地址为：http://www.xxxx.com/xxxx.aspx，则拍码后跳转的网址为： </p>
					<p> （注册码）http://www.xxxx.com/xxxx.aspx?code=MA.156.110108.52/91.12000000.1/xxxx </p>
					<p> （备案码）http://www.xxxx.com/xxxx.aspx?code=xxxx&BaseCode=MA.156.110108.52/91.12000000.1/ </p>
					<p>举例说明四：假如IDcode码为MA.156.101010.3/10.232324.11/201703233 </p>
					<p>平台提供解析地址参数化配置功能，最多可支持四个参数，参数名与IDcode码段对应关系如下 </p>
					<p>{fullCode}对应 MA.156.101010.3/10.232324.11/201703233 </p>
					<p>{mainCode}对应 MA.156.101010.3 </p>
					<p>{catalogCode}对应 10.232324.11 </p>
					<p>{userCode}对应 201703233 </p>
					<p>使用方法举例1： </p>
					<p>解析地址 http://news.dfasfsa.com/html/{userCode}.html</p>
					<p>跳转网址 http://news.dfasfsa.com/html/201703233.html </p>
					<p>使用方法举例2： </p>
					<p>解析地址 http://news.dfasfsa.com/html/{catalogCode}/{userCode}.html </p>
					<p>跳转网址 http://news.dfasfsa.com/html/10.232324.11/201703233.html </p>
					<p>使用方法举例3： </p>
					<p>解析地址 http://news.dfasfsa.com/html/{fullCode}.html </p>
					<p>跳转网址 http://news.dfasfsa.com/html/MA.156.101010.3/10.232324.11/201703233.html </p>
					<p>举例说明五：假如IDcode简码为gkR9ffAPko </p>
					<p>平台提供解析地址参数化配置功能，参数名与IDcode简码对应关系如下 </p>
					<p>{shortCode}对应 gkR9ffAPko </p>

					<p>使用方法举例1： </p>
					<p>解析地址 http://www.xxxx.com/xxxx.aspx?id=1{shortCode}</p>
					<p>跳转网址 http://www.xxxx.com/xxxx.aspx?id=1&code=gkR9ffAPko</p>
					<p>使用方法举例2： </p>
					<p>解析地址 http://www.xxxx.com/xxxx.aspx?id={shortCode}</p>
					<p>跳转网址 http://www.xxxx.com/xxxx.aspx?id=gkR9ffAPko</p>
					<p>使用方法举例3： </p>
					<p>解析地址 http://www.xxxx.com/xxxx.aspx/{shortCode}</p>
					<p>跳转网址 http://www.xxxx.com/xxxx.aspx/?code=gkR9ffAPko</p>
					<p>注：</p>
					<p> code、BaseCode为参数名，MA.156.110108.52/91.12000000.1/xxxx为完整码号。</p>
					<p>2、通过http://www.xxxx.com/xxxx.aspx页面中的函数接收码号，再根据需要，对码号进行处理，接收方式 可以为Request["code"]或者返回类型 函数名（参数类型1 参数名1，·····，参数类型n 参数名n，string code）。</p>
					<p>3、此处以Asp.net举例，接收页面还可以是jsp、php等，接收方式类似。</p>
					<p>4、若还有其他疑问，请联系您的网站开发商。</p>
				</div>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit">保存</el-button>
				<el-button @click="$router.push({name:'genrelist' })">返回列表</el-button>

			</el-form-item>
		</el-form>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				name: 'genreanalysis',
				form: {
					name: '',
					test: ''
				},
				idshow: true,
				analysisData: '',
				rules: {
					name: [{
							required: true,
							message: '请输入地址',
							trigger: 'blur'
						},

						{
							// eslin -disable-next-line
							pattern: /^((http(s)?):\/\/)?(((\w(\-*\w)*\.)+[a-zA-Z]{2,4})|(((1\d\d|2([0-4]\d|5[0-5])|[1-9]\d|\d).){3}(1\d\d|2([0-4]\d|5[0-5])|[1-9]\d|\d).?))(:\d{0,5})?(\/+.*)*$/,

							message: '地址格式不正确',
							trigger: 'blur'
						}

					],
					test: [{
							required: true,
							message: '请输入地址',
							trigger: 'blur'
						},
						{
							// eslin -disable-next-line
							pattern: /^((http(s)?):\/\/)?(((\w(\-*\w)*\.)+[a-zA-Z]{2,4})|(((1\d\d|2([0-4]\d|5[0-5])|[1-9]\d|\d).){3}(1\d\d|2([0-4]\d|5[0-5])|[1-9]\d|\d).?))(:\d{0,5})?(\/+.*)*$/,
							message: '地址格式不正确',
							trigger: 'blur'
						},

					]

				}
			}
		},
		props: {
			id: [String, Number],
			maid: [String, Number],
			idcode: [String, Number]

		},
		created() {
			this.getanalysis();
		},
		methods: {
			onSubmit() {

				this.$refs.form.validate((valid) => {
					if(valid) {
						if(this.form.test.indexOf(this.form.name) != -1) {
							let {
								form
							} = this;
							this.$http.post(this.$api + '/categoryApply/saveCategoryAnalyUrl', {
								categoryreg_id: this.id,
								anayUrl: form.name,
								testUrl: form.test
							}).then(res => {
								if(res.body.result === 1) {
									this.$message({
										message: '保存成功,请点击返回列表查看',
										type: 'success',
										duration: '1000'
									});
									setTimeout(() => {
										this.$router.push('/genrelist')
									}, 1000)
								} else {
									this.$message.error(res.body.message);
								}
							})
						} else {
							this.$message.error('测试地址必须包含解析地址！');

						}

					} else {
						this.$message.error('填写有误，请仔细检查重新提交');
					}

				})

			},
			getanalysis() {

				this.$http.get(this.$api + '/categoryApply/getAnalyUrlByRegID', {
					params: {
						categoryreg_id: this.id
					}
				}).then(res => {
					//					console.log(res)
					if(res.body.result === 1) {
						this.idshow = false;
						this.analysisData = res.body.entity
						this.form.test = res.body.entity.testAnalyUrl;
						this.form.name = res.body.entity.analyUrlForExamine
					}

				})
			}
		},
		//		beforeRouteUpdate(to, from, next){
		//			console.log(to)
		//			next();
		//			
		//		}
	}
</script>

<style lang="scss">
	.analysis {
		text-align: left;
		width: 80%;
		padding: 50px 0 0 0;
	}
	
	.notice {
		background: #e5f6fd;
		border: 1px solid #cdecf7;
		padding: 10px 20px;
		margin: 15px 0;
		margin-top: 20px;
		position: relative;
		line-height: 1.5;
		color: #999999;
		p {
			color: #999999;
		}
		.sign {
			text-decoration: underline;
			color: red;
		}
	}
	
	.Genform-box {
		padding: 50px;
		.Genhead {
			.f-fl {
				text-align: left;
				width: 56%;
				.item {
					/*width: 100%;*/
					/*border: solid red 1px;*/
					padding: 10px 0;
					.tit {
						font-weight: 500;
						display: inline-block;
						font-size: 18px;
						/*padding: ;*/
						color: #2C3E50;
					}
					.context {
						display: inline-block;
						color: #8C939D;
						font-size: 16px;
					}
				}
			}
		}
		.Gform {
			margin-top: 20px;
			text-align: left;
			/*width: 50%;*/
			max-width: 1000px;
		}
	}
</style>